import { Card, Stack, Button } from "react-bootstrap";
import { BarChartLineFill } from "react-bootstrap-icons";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import annotationPlugin from "chartjs-plugin-annotation";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useMemo, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import LoadingIndicator from "../LoadingIndicator";
import ErrorResponse from "../ErrorResponse";
import RATooltip from "../RATooltip";
import { doughnutOptions, htmlLegendPlugin } from "../chartOptions";
import HealthTrend from "./HealthTrend";

ChartJS.register(ArcElement, Tooltip, Legend, annotationPlugin, ChartDataLabels);

export default function ListenerGroupsCard({ data, formData, loading, error, isFullDaypart = true }) {
    const [showTrend, setShowTrend] = useState(false);
    const chartData = useMemo(() => {
        if (data) {
            return {
                labels: ["Light", "Moderate", "Heavy"],
                datasets: [
                    {
                        label: "Time Frame",
                        type: "doughnut",
                        backgroundColor: ["#7BA7CC", "#396A93", "#284B67"],
                        data: [data.light.time_frame, data.moderate.time_frame, data.heavy.time_frame],
                        datalabels: {
                            anchor: "end",
                        },
                    },
                    {
                        label: "Average",
                        type: "doughnut",
                        backgroundColor: ["#7BA7CC", "#396A93", "#284B67"],
                        data: [data.light.average, data.moderate.average, data.heavy.average],
                        datalabels: {
                            anchor: "start",
                        },
                    },
                ],
            };
        }
    }, [data]);

    return (
        <Card>
            <Card.Header className={`d-flex align-items-center px-2 ${isFullDaypart ? "" : "health-daypart-header"}`}>
                <span className={`offset-1 flex-grow-1`}>Listener Groups</span>
                <div className="d-flex justify-content-end">
                    <Button variant="ra-yellow" className="py-0 d-flex align-items-center me-2" size="sm" onClick={() => setShowTrend(true)}>
                        <BarChartLineFill height={16} width={16} className="me-1" /> Trend
                    </Button>
                    <RATooltip size={20}>
                        <Stack gap={2}>
                            <span>Percentage of total sessions by listeners group.</span>
                            <span>
                                <b>Heavy</b>- 7x a week.
                            </span>
                            <span>
                                <b>Moderate</b>- 4-6x a week.
                            </span>
                            <span>
                                <b>Light</b>- 1-3x a week.
                            </span>
                        </Stack>
                    </RATooltip>
                </div>
            </Card.Header>
            <Card.Body className="py-0 card-health-chart d-flex">
                {loading ? (
                    <LoadingIndicator width={85} />
                ) : error ? (
                    <ErrorResponse errorCode={error} />
                ) : (
                    <>
                        <Stack id="legend-container-listener-groups" className="py-3"></Stack>
                        <Doughnut data={chartData} options={doughnutOptions("legend-container-listener-groups")} plugins={[htmlLegendPlugin]} />
                    </>
                )}
            </Card.Body>
            {showTrend && (
                <HealthTrend
                    show={showTrend}
                    onHide={() => setShowTrend(false)}
                    selection="Listener Groups"
                    formData={formData}
                    metrics={[
                        { key: "unique_listeners_percent", label: "Light", color: "#7BA7CC" },
                        { key: "unique_listeners_percent", label: "Moderate", color: "#396A93" },
                        { key: "unique_listeners_percent", label: "Heavy", color: "#284B67" },
                    ]}
                    time={false}
                    percentage={true}
                    listenerGroupChart={true}
                />
            )}
        </Card>
    );
}
